module.exports = __webpack_public_path__ + "img/404.16bf7149.png";